import { makeStyles, Theme } from '@material-ui/core/styles';
const imgPath = `${process.env.PUBLIC_URL}/assets/landing2020`;
export const useBenefitsSectionStyles = makeStyles((theme: Theme) => ({
    section: {
        flexGrow: 1,
        position: 'relative',
        backgroundSize: 'cover',
        backgroundImage: `url("${imgPath}/background-landing2020.png")`,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
    },
    mask: {
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(360deg, rgba(0, 0, 0, 0.8) 32.37%, rgba(0, 0, 0, 0) 100%)',
        opacity: '0.8',
        padding: '63px 96px 45px 96px',
        [theme.breakpoints.down('md')]: {
            padding: '120px 90px 45px 90px',
        },
    },
    benefitsContainer: {
        width: '100%',
    },
    title: {
        fontWeight: 600,
        fontSize: '36px',
        lineHeight: '40px',
        color: theme.colors.lightGreen,
        fontStyle: 'normal',
        textTransform: 'uppercase',
    },
    list: {
        margin: '38px 0 75px',
        paddingLeft: 0,
        display: 'flex',
        justifyContent: 'space-between',
    },
    listColumn: {
        width: '45%',
    },
    quote: {
        alignItems: 'center',
        position: 'relative',
    },
    quoteImage: { width: '113px', height: '113px' },
    quoteSeparator: { height: '139px', marginLeft: '20px', marginRight: '28px' },
    quoteDescription: {
        paddingLeft: '170px',
        position: 'absolute',
        top: '0',
        fontWeight: 300,
        fontSize: '22px',
        lineHeight: '26px',
        color: theme.colors.white,
    },
    quoteDescriptionSmall: { fontSize: '14px', lineHeight: '16px' },
    trust: {
        paddingTop: '67px',
    },
    trustText: {
        fontWeight: 300,
        fontSize: '12px',
        lineHeight: '14px',
        color: theme.colors.white,
    },
    trustLogos: {
        marginTop: '23px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    trustLogo: { width: 'auto', height: '40px' },
    trustEurope: {
        marginTop: '57px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    trustEuropeText: {
        fontWeight: 300,
        fontSize: '12px',
        lineHeight: '14px',
        color: theme.colors.white,
        margin: '0 20px 0 0',
    },
    trustEuropeLogo: { width: '45px', height: 'auto' },
}));
